export const BUSINESS_TIME_ZONE = 'America/Port-au-Prince';

export function businessToday() {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: BUSINESS_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());

  const values = {};
  parts.forEach((part) => {
    if (part.type !== 'literal') values[part.type] = part.value;
  });
  return `${values.year}-${values.month}-${values.day}`;
}

export function defaultDateRange() {
  const today = businessToday();
  return { dateFrom: today, dateTo: today };
}

export function validateDateRange(dateFrom, dateTo) {
  if (dateFrom && dateTo && dateFrom > dateTo) {
    return 'La date de début ne peut pas être supérieure à la date de fin.';
  }
  return '';
}

export function businessDateOffset(days = 0) {
  const today = businessToday();
  const [year, month, day] = today.split('-').map(Number);
  const d = new Date(Date.UTC(year, month - 1, day + Number(days || 0)));
  return [
    String(d.getUTCFullYear()).padStart(4, '0'),
    String(d.getUTCMonth() + 1).padStart(2, '0'),
    String(d.getUTCDate()).padStart(2, '0'),
  ].join('-');
}
